import {Visibility, VisibilityOff} from '@mui/icons-material'
import {
  Autocomplete,
  Button,
  IconButton,
  InputAdornment,
  Step,
  StepLabel,
  Stepper,
  TextField,
} from '@mui/material'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import axios from 'axios'
import {envBackHost} from 'GLOBAL/envVariables'
import {useEffect, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {normalAlert, resultAlert, validationAlert} from 'utils/CustomAlert/Alert'
import {hashPasswordParser} from 'utils/func/justUtils'
import {isId, isPhone, isPw} from 'utils/validation/validation'
import Logo from '../images/meterarium_new_logo.gif'
import './../joinPage.css'

interface State {
  password: string
  checkPassword: string
  showPassword: boolean
}

const JoinRegitstration = () => {
  const navigate = useNavigate()
  const [completed, setCompleted] = useState(false)
  const steps = ['약관동의', '회원정보입력', '회원가입완료']
  const [idCheck, setIdCheck] = useState(false)
  const [submitData, setSubmitData] = useState({
    id: '',
    password: '',
    phoneNumber: '',
    customerNumber: '',
    officeId: '',
  })

  const [registration, setRegistration] = useState({
    customerNumber: '',
    phoneNumber: '',
    password: '',
    checkPassword: '',
  })
  const [pwForm, setPwForm] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [phoneNumberForm, setPhoneNumberForm] = useState(false)
  const [idForm, setIdForm] = useState(false)
  const [idValue, setIdValue] = useState('')
  const [koreanRegions, setKoreanRegions] = useState<any>([])

  const getKoreanRegions = async () => {
    axios.get(`${envBackHost}/city`).then((res) => {
      const filtered = (res.data.res ?? []).filter((item: any) => item?.cityName)
      setKoreanRegions(filtered)
    })
  }

  const pwCheckForm = (prop: keyof State, e: any) => {
    const {value} = e.target
    setRegistration({...registration, [prop]: value})
    if (prop === 'password') {
      setPwForm(isPw(value))
    }
  }

  const idValidation = (e: any) => {
    const {value} = e.target
    setIdValue(value)
    if (isId(value)) {
      setIdForm(true)
      setSubmitData({...submitData, id: value})
    } else {
      setIdForm(false)
    }
  }

  const phoneValidation = (e: any) => {
    const {value} = e.target
    if (isPhone(value)) {
      setPhoneNumberForm(true)
      setRegistration({...registration, phoneNumber: e.target.value})
    } else {
      setPhoneNumberForm(false)
    }
  }

  const postRegistration = async () => {
    if (registration.password !== registration.checkPassword) {
      await normalAlert('비밀번호가 일치하지 않습니다.')
      return
    }
    if (registration.password === '' || registration.checkPassword === '') {
      await normalAlert('비밀번호를 입력해주세요.')
      return
    }
    if (!pwForm) {
      await normalAlert('비밀번호 형식이 올바르지 않습니다.')
      return
    }
    if (registration.customerNumber === '') {
      await normalAlert('수용가 번호를 입력해주세요.')
      return
    }
    if (registration.phoneNumber === '') {
      await normalAlert('핸드폰 번호를 입력해주세요.')
      return
    }
    if (!phoneNumberForm) {
      await normalAlert('핸드폰 번호 형식이 올바르지 않습니다.')
      return
    }
    if (submitData.officeId === '') {
      await normalAlert('지역을 선택해주세요.')
      return
    }

    submitData.password = await hashPasswordParser(submitData.id, registration.password)
    axios
      .post(`${envBackHost}/client/account`, {
        id: submitData.id,
        password: submitData.password,
        phoneNumber: registration.phoneNumber,
        customerNumber: registration.customerNumber,
        officeId: submitData.officeId,
      })
      .then(async (res) => {
        if (res.data.resultCode === 11) {
          await validationAlert(res.data.message, 'error')
          return
        } else if (res.data.resultCode === 20) {
          await validationAlert(res.data.message, 'error')
        } else {
          await resultAlert(res.data)
          if (res.data.resultCode === 0) {
            setCompleted(true)
            navigate('/')
            return
          }
          return
        }
      })
      .catch(async (e) => {
        await resultAlert({resultCode: e.response.status})
      })
  }

  useEffect(() => {
    getKoreanRegions()
  }, [])

  return (
    <div className={'join-body w-full min-h-screen relative p-3'}>
      {/* 로고 */}
      <div className={'flex justify-center m-6 md:m-10'}>
        <img
          src={Logo}
          alt='logo'
          className={'w-full max-w-xs md:max-w-[700px]'}
          style={{borderRadius: '28px'}}
        />
      </div>

      {/* 중앙 카드 */}
      <div className={'flex justify-center px-2 md:px-6'}>
        <Paper elevation={3} className={'p-5 w-full md:max-w-[80%]'}>
          {/* 스텝퍼 */}
          <Box sx={{width: '100%'}} className={'mb-5'}>
            <Stepper activeStep={completed ? 2 : 1} alternativeLabel>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </Box>

          <div className={'text-center mb-4'}>
            <h2 className={'text-[35px]'}>회원정보입력</h2>
          </div>

          {/* 폼 그리드 */}
          <div className={'grid grid-cols-1 md:grid-cols-2 gap-4'}>
            {/* 지역선택 */}
            <div>
              <Autocomplete
                disablePortal
                fullWidth
                id='choose-office'
                options={koreanRegions}
                disableClearable={true}
                clearText={'초기화'}
                noOptionsText={'검색 결과가 없습니다.'}
                getOptionLabel={(option: any) => option.cityName}
                onChange={(_, rowValue: any) => {
                  setSubmitData({...submitData, officeId: rowValue?.officeId})
                }}
                sx={{fontSize: '1.5rem', color: '#fff'}}
                renderInput={(params) => (
                  <div className={'flex gap-3'}>
                    <TextField
                      {...params}
                      fullWidth
                      label='지역선택'
                      focused
                      placeholder={'지역을 선택해주세요.'}
                    />
                  </div>
                )}
              />
            </div>

            {/* 수용가 번호 */}
            <div>
              <TextField
                fullWidth
                variant='outlined'
                label='수용가 번호'
                required
                type='number'
                autoComplete='new-password'
                onChange={(e) => setRegistration({...registration, customerNumber: e.target.value})}
              />
            </div>

            {/* 아이디 */}
            <div className={'md:col-span-2'}>
              <TextField
                fullWidth
                variant='outlined'
                label='아이디'
                required
                disabled={idCheck}
                onChange={(e) => idValidation(e)}
                inputProps={{
                  onInput: (e: any) => {
                    e.target.value = e.target.value.replace(/[ㄱ-ㅎㅏ-ㅣ가-힣]/g, '')
                  },
                }}
                helperText={
                  idValue === '' ? (
                    <span className={'font-bold text-blue-600'}>영문, 숫자 2~20자리</span>
                  ) : idForm ? (
                    <span className={'font-bold text-green-600'}>올바른 아이디 형식입니다.</span>
                  ) : (
                    <span className={'font-bold text-red-500'}>잘못된 아이디 형식입니다.</span>
                  )
                }
                FormHelperTextProps={{style: {fontSize: '1rem'}}}
              />
            </div>

            {/* 핸드폰 번호 */}
            <div className={'md:col-span-2'}>
              <TextField
                fullWidth
                variant='outlined'
                required
                autoComplete='new-password'
                label='핸드폰 번호'
                helperText={
                  registration.phoneNumber === '' ? (
                    <span className={'font-bold text-blue-600'}>- 를 제외하고 입력하세요.</span>
                  ) : phoneNumberForm ? (
                    <span className={'font-bold text-green-600'}>올바른 연락처 형식입니다.</span>
                  ) : (
                    <span className={'font-bold text-red-500'}>잘못된 연락처 형식입니다.</span>
                  )
                }
                FormHelperTextProps={{style: {fontSize: '1rem'}}}
                onChange={(e) => phoneValidation(e)}
              />
            </div>

            {/* 비밀번호 */}
            <div>
              <TextField
                fullWidth
                variant='outlined'
                label='비밀번호'
                required
                type={showPassword ? 'text' : 'password'}
                autoComplete='new-password'
                onChange={(e) => pwCheckForm('password', e)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      <IconButton onClick={() => setShowPassword(!showPassword)} edge='end'>
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>

            {/* 비밀번호 확인 */}
            <div>
              <TextField
                fullWidth
                variant='outlined'
                label='비밀번호 확인'
                required
                type={showPassword ? 'text' : 'password'}
                autoComplete='new-password'
                onChange={(e) => pwCheckForm('checkPassword', e)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      <IconButton onClick={() => setShowPassword(!showPassword)} edge='end'>
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>

            {/* 비밀번호 유효성 메시지 */}
            <div className={'md:col-span-2 text-base'}>
              {registration.checkPassword === '' ? (
                <div className={'mt-1 font-bold'}>
                  {registration.password === '' ? (
                    <div className={'text-blue-600'}>
                      4자리 이상의 영문 대·소문자, 숫자, 특수문자 사용 가능
                    </div>
                  ) : pwForm ? (
                    <span className={'text-green-600'}>올바른 비밀번호 형식입니다.</span>
                  ) : (
                    <span className={'text-red-500'}>잘못된 비밀번호 형식입니다.</span>
                  )}
                </div>
              ) : registration.checkPassword === registration.password ? (
                <span className={'text-green-600 font-bold'}>비밀번호가 일치합니다.</span>
              ) : (
                <span className={'text-red-500 font-bold'}>비밀번호가 일치하지 않습니다.</span>
              )}
            </div>
          </div>

          {/* 버튼 */}
          <div className={'mt-5 flex justify-center gap-3'}>
            <Button
              variant='contained'
              color='inherit'
              size='large'
              onClick={() => {
                setCompleted(false)
                navigate('/')
              }}
            >
              취소
            </Button>
            <Button
              variant='contained'
              color='primary'
              size='large'
              onClick={async () => await postRegistration()}
            >
              확인
            </Button>
          </div>
        </Paper>
      </div>
    </div>
  )
}

export default JoinRegitstration
